import React, { useState } from 'react';
import { Pencil, Trash2, Check, X } from 'lucide-react';

function formatTimeWithTimezone(dateString, timezone) {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    if (timezone) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZone: timezone });
    }
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

const PromptCard = ({ prompt, time, date, timezone, onEdit, onDelete }) => {
  const [editMode, setEditMode] = useState(false);
  const [editValue, setEditValue] = useState(prompt);

  const handleSave = () => {
    setEditMode(false);
    if (onEdit) onEdit(editValue);
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditValue(prompt);
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this entry?')) {
      onDelete();
    }
  };

  return (
    <div className="bg-emerald-50/80 backdrop-blur-sm rounded-2xl border border-emerald-100/50 hover:border-emerald-200 p-4 mb-3 transition-all duration-200 hover:shadow-lg group">
      <div className="flex justify-between items-start">
        <div className="flex-1 mr-4">
          {editMode ? (
            <input
              type="text"
              value={editValue}
              onChange={e => setEditValue(e.target.value)}
              className="w-full p-2 border border-emerald-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all duration-200 bg-white/80"
              autoFocus
            />
          ) : (
            <div className="text-gray-800 font-medium text-base mb-1 break-words">{prompt}</div>
          )}
          <div className="text-sm text-gray-500">{formatTimeWithTimezone(date, timezone)}</div>
        </div>
        <div className="flex gap-2 relative z-10">
          {editMode ? (
            <>              <button 
                onClick={handleSave}
                className="w-8 h-8 flex items-center justify-center bg-emerald-100 hover:bg-emerald-200 text-emerald-700 rounded-lg transition-all duration-200 hover:scale-105 cursor-pointer"
                title="Save changes"
                style={{ pointerEvents: 'auto' }}
              >
                <Check size={16} />
              </button>
              <button 
                onClick={handleCancel}
                className="w-8 h-8 flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg transition-all duration-200 hover:scale-105 cursor-pointer"
                title="Cancel editing"
                style={{ pointerEvents: 'auto' }}
              >
                <X size={16} />
              </button>
            </>
          ) : (            <>              <button 
                onClick={() => setEditMode(true)}
                className="w-8 h-8 flex items-center justify-center bg-blue-100 hover:bg-blue-200 text-blue-600 rounded-lg transition-all duration-200 hover:scale-105 cursor-pointer"
                title="Edit entry"
                style={{ pointerEvents: 'auto' }}
              >
                <Pencil size={14} />
              </button>
              <button 
                onClick={handleDelete}
                className="w-8 h-8 flex items-center justify-center bg-red-100 hover:bg-red-200 text-red-600 rounded-lg transition-all duration-200 hover:scale-105 cursor-pointer"
                title="Delete entry"
                style={{ pointerEvents: 'auto' }}
              >
                <Trash2 size={14} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromptCard;
